
define('template!adminWebhookHistoryContentView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="libelle">\n  ' +
((__t = ( _.i18n('webhook_history.invoice-number') )) == null ? '' : __t) +
'\n</div>\n<div class="value">' +
((__t = ( content )) == null ? '' : __t) +
'</div>\n';

}
return __p
};});

